module.exports = __webpack_public_path__ + "static/media/atletico-go.712b63fe.svg";